export const data1 =[
    {
        img: 'https://www.washmartindia.in/static/media/team_filled_icon.e45651dc.svg',
        title: 'Digitalized Customer Management',
        desc: 'Manage your customers digitally with the reduction to the paperwork. Automatic Messaging (SMS) system to update order status.'
    },
    {
        img: 'https://www.washmartindia.in/static/media/team_filled_icon.e45651dc.svg',
        title: 'Auto-generated billing & tagging system',
        desc: 'Generate and print customer order bills and tags for clothes automatically. Accept advance payments, apply discount coupons, track defects in clothes, and extra or urgent delivery charges.'
    },
    {
        img: 'https://www.washmartindia.in/static/media/team_filled_icon.e45651dc.svg',
        title: 'Customer Management & Order History',
        desc: 'Track customer orders and detailed history, apply discounts based on customer credibility. Manage payment dues & advance payments.'
    },
    {
        img: 'https://www.washmartindia.in/static/media/team_filled_icon.e45651dc.svg',
        title: 'Customized Laundry Services',
        desc: 'Add own customized services that your laundry provides. Change base prices of services. Add services based on units or weights.'
    },
    {
        img: 'https://www.washmartindia.in/static/media/team_filled_icon.e45651dc.svg',
        title: 'Annual Costing & Report Generation',
        desc: 'Pay minimal charges annually to give digital wings to your laundry. Get annual reports of generated revenue, processed orders, number of customers, the addition of new customers, and much more.'
    }
]

export const data2 =[
    {
        title:'Super Drycleaners',
        loc:'Hadapsar, Pune'
    },
    {
        title:'Wash N fresh',
        loc:'Kothrud, Pune'
    },
    {
        title:'Skyy Dry Cleaners',
        loc:'Chakan, Pune'
    },
    {
        title:'Clean N Dry Laundry',
        loc:'Warje, Pune'
    },
    {
        title:'Om Clothing and drycleaners',
        loc:'Ambegaon BK, Pune'
    },
    {
        title:'Sai Drycleaning',
        loc:'Fursungi, Pune'
    },
    {
        title:'Star Drycleaners',
        loc:'Shivajinagar, Pune'
    },
    {
        title:'Jagdamba Laundry',
        loc:'Wagholi, Pune'
    },
]

export const data3=[
    {
        desc:'Easy to use and hassle-free. As it offers the same portal from accepting orders till bill generation. Data maintenance is very easy. Even tracking order status is simplified as a separate option given for running orders.',
        char:'G',
        title:'Ganesh Ghanwat',
        span:'Super Dry Cleaners',
        color:"rgb(232, 92, 204)"
    },
    {
        desc:'Thank you for helping me digitalize my laundry, now I can keep end-to-end track of orders and customers',
        char:'R',
        title:'Rahul Patil',
        span:'Skyy Dry Cleaners',
        color:"rgb(143, 177, 232"
    },
    {
        desc:'WashMartIndia is the best solution available out there for any laundry owner to simplify the management tasks. Thank you for delivering exact services',
        char:'S',
        title:'Satish Deokar',
        span:'Clean N Dry Laundry',
        color:"rgb(245, 189, 249)"
    },
    {
        desc:'Bills & Tag generation system is so efficient, now I can keep track of exact cloth conditions and it has helped me out to avoid cloth misplacements',
        char:'V',
        title:'Vijay Sabale',
        span:'Om Clothing and drycleaners',
        color:"rgb(73, 224, 8)"
    },
    {
        desc:'Discounts & Due management system is very useful. WashMartIndia has made my work easy and efficient. Best Application!',
        char:'R',
        title:'Raju Shinde',
        span:'Sai Drycleaning',
        color:"rgb(255, 183, 201)"

    },
    {
        desc:'Very easy to use, I have been using it for a while now and I can say that switching to WashMartIndia from the previous application was the best decision I made',
        char:'S',
        title:'Shiv Kumar',
        span:'Star Drycleaners',
        color:"rgb(252, 85, 163)"

    },
    {
        desc:'वॉशमार्ट india मुळे मला हिशोब ठेवणे खूप सोप झालंय. Website वापरायला सोपी आहे. यामध्ये laundry चालवण्यासाठीचे लागणारे सगळे options आहेत. त्यामुळे management च्या कामामध्ये वेळ न घालवता मला माझा business expand करायला वेळ मिळतो.',
        char:'P',
        title:'Pandurang Mhetre',
        span:'Jagdamba Laundry',
        color:"rgb(242, 115, 111)"

    },
    {
        desc:'WashmartIndia is the best solution for laundry management that I m using. It eases my all fussy work and helps to keep me and my work, organized. It keeps all laundry accounts up-to-date',
        char:'J',
        title:'Jignesh Shah',
        span:'Washhub Laundry',
        color:"rgb(164, 248, 252)"

    },
    {
        desc:'Best Dashboard & Great Service, You have helped me go digital, now my paper-work is reduced by 80%. Thanks for this application',
        char:'R',
        title:'Rohit Mane',
        span:'Smart Wash',
        color:"rgb(234, 105, 213)"

    },
]